import { create } from "zustand";

export interface SyncState {
  online: boolean;
  queueDepth: number;
  lastSyncAt: number | null;
  lastError: string | null;
  setOnline: (v: boolean) => void;
  setQueueDepth: (v: number) => void;
  setLastSyncAt: (v: number) => void;
  setLastError: (v: string | null) => void;
}

export const useSyncStatus = create<SyncState>((set) => ({
  online: typeof navigator !== "undefined" ? navigator.onLine : true,
  queueDepth: 0,
  lastSyncAt: null,
  lastError: null,
  setOnline: (v) => set({ online: v }),
  setQueueDepth: (v) => set({ queueDepth: v }),
  setLastSyncAt: (v) => set({ lastSyncAt: v }),
  setLastError: (v) => set({ lastError: v }),
}));
